import { render, staticRenderFns } from "./Families.vue?vue&type=template&id=511f5b74&scoped=true&"
import script from "./Families.ts?vue&type=script&lang=ts&"
export * from "./Families.ts?vue&type=script&lang=ts&"
import style0 from "./Families.vue?vue&type=style&index=0&id=511f5b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f5b74",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QIcon});
